import Swiper from 'swiper';
import { Navigation } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/navigation';

// Product Slider
document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('.product-slider').forEach((slider) => {
        const sliderShell = slider.closest('.product-slider-shell');
        if (!sliderShell) return;

        new Swiper(slider, {
            modules: [Navigation],
            slidesPerView: 1,
            centeredSlides: true,
            loop: true,
            spaceBetween: 50,
            grabCursor: true,
            navigation: {
                nextEl: sliderShell.querySelector('.product-slider-nav-next'),
                prevEl: sliderShell.querySelector('.product-slider-nav-prev'),
            },
        });
    });
});


